import { CancelablePromise, OpenAPI, type Response } from "@/api";
import { request as __request } from "@/api/core/request";
import { ListRequest } from "@/api/models/ListRequest";
import { ToDeleteRequest } from "@/utils/slice";
import { RechargeListResponse } from "@/api/models/recharge/RechargeListResponse";
import { RechargeAddRequest } from "@/api/models/recharge/RechargeAddRequest";
import { RechargeUpdateRequest } from "@/api/models/recharge/RechargeUpdateRequest";

export class RechargeService {
  public static Add(body: RechargeAddRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/recharge/activity",
      body: body,
    });
  }

  public static ListAll(
    body: ListRequest
  ): CancelablePromise<RechargeListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/recharge/activity",
      body: body,
    });
  }

  public static Update(
    body: RechargeUpdateRequest
  ): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/recharge/activity",
      body: body,
    });
  }

  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/recharge/activity",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/recharge/activity/drop",
      body: ToDeleteRequest(body),
    });
  }
}
